// extracted by mini-css-extract-plugin
module.exports = {"link":"TravelModeLink_link__MSc46"};